import React from 'react';
import { formatInviteStatus } from '../../../services/inviteService';

/**
 * InviteStatusBadge Component
 * Displays the status of an invite with appropriate colors and styling
 */
const InviteStatusBadge = ({ status, className = '' }) => {
  const statusConfig = formatInviteStatus(status);
  
  return (
    <span
      className={`
        inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium border
        ${statusConfig.bgColor} ${statusConfig.textColor} ${statusConfig.borderColor}
        ${className}
      `}
    >
      {statusConfig.label}
    </span>
  );
};

export default InviteStatusBadge;